import * as t from "io-ts";

import { ImageURL, SafeHTML } from "./nominals";
import {
    BackgroundStylesSubBlock,
    ListBlock,
    PageChooserBlock,
    ResponsiveVisibilitySubBlock,
    SpacingSubBlock,
    StructBlock,
} from "./streamfield-blocks";

/**
 * See model tsicommon.cms.models.value_props.ValueProp
 */
const ValueProp = StructBlock(
    {
        title: t.string,
        subtitle: t.string,
        show_tooltip: t.boolean,
        tooltip_contents: SafeHTML,
    },
    {
        icon: t.readonly(
            t.type({
                id: t.number,
                title: t.string,
                url: ImageURL,
            }),
        ),
    },
);

export const ValuePropBarBlock = StructBlock(
    {
        value_props: ListBlock(ValueProp),
    },
    {
        spacing: SpacingSubBlock,
        background_style: BackgroundStylesSubBlock,
        responsive_visibility: ResponsiveVisibilitySubBlock,
    },
);

export type IValuePropBarBlock = t.TypeOf<typeof ValuePropBarBlock>;

export type IServiceFooterValueProp = Readonly<{
    title: string;
    description: string;
    icon: Readonly<{
        title: string;
        url: string;
    }>;
    learn_more_link: PageChooserBlock;
}>;

export type IServiceFooterValueProps = Readonly<{
    title: string;
    value_props: readonly IServiceFooterValueProp[];
}>;
